module.exports = __webpack_public_path__ + "static/media/2.aa666287.svg";